import { render, staticRenderFns } from "./ExpandableExplanation.vue?vue&type=template&id=1d60c231&scoped=true"
import script from "./ExpandableExplanation.vue?vue&type=script&lang=js"
export * from "./ExpandableExplanation.vue?vue&type=script&lang=js"
import style0 from "./ExpandableExplanation.vue?vue&type=style&index=0&id=1d60c231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60c231",
  null
  
)

export default component.exports